/**
 * Retraduction des cibles en fourchette vers les MOTS de l'écran de saisie.
 *
 * Une contribution PAMI est saisie en attente (score bas / moyen / élevé, ou pas
 * d'attente particulière) mais stockée et agrégée sous forme d'intervalle.
 * Toute restitution doit refaire le chemin inverse, sinon elle renvoie au
 * référent des bornes qu'il n'a jamais vues.
 */
import { LIBELLE_ATTENTE } from "../../../../convex/referentiel/fourchette";

/**
 * Attente lue dans la FORME de la zone : ouverte vers le haut → élevé, ouverte
 * vers le bas → bas, sinon par son centre. Couvre aussi les zones historiques
 * (importance × niveau, bornes saisies au curseur), plus larges mais orientées
 * de la même façon.
 */
export function libelleAttentePourCible(
  cible: { min: number; max: number },
  echelle: { min: number; max: number },
): string {
  const ouverteEnHaut = cible.max >= echelle.max;
  const ouverteEnBas = cible.min <= echelle.min;
  if (ouverteEnHaut && !ouverteEnBas) return LIBELLE_ATTENTE.haut;
  if (ouverteEnBas && !ouverteEnHaut) return LIBELLE_ATTENTE.bas;
  const amplitude = echelle.max - echelle.min;
  const centre = ((cible.min + cible.max) / 2 - echelle.min) / amplitude;
  if (centre >= 0.65) return LIBELLE_ATTENTE.haut;
  if (centre <= 0.35) return LIBELLE_ATTENTE.bas;
  return LIBELLE_ATTENTE.moyen;
}
